module.exports = __webpack_public_path__ + "img/店铺排行2.f0501e32.png";